module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust1_m.e9922455d285d21a105ca25fa24fe8f1.png";